import api from './api';

const PUBLIC_API_KEY = 'admin-panel-public-key-2024';

export const publicIpCheckApi = {
  // Check if current IP is whitelisted
  checkIp: async (): Promise<{
    ip: string;
    isWhitelisted: boolean;
    message: string;
  }> => {
    return api.get('/public/ip-check', {
      headers: {
        'x-api-key': PUBLIC_API_KEY
      }
    });
  },

  // Check service status
  getStatus: async (): Promise<{
    status: string;
    message: string;
  }> => {
    return api.get('/public/ip-check/status', {
      headers: {
        'x-api-key': PUBLIC_API_KEY
      }
    });
  },

  // Get whitelist status (public endpoint with API key)
  getWhitelistStatus: async (): Promise<{
    enabled: boolean;
  }> => {
    const response = await api.get('/public/ip-check/whitelist-status', {
      headers: {
        'x-api-key': PUBLIC_API_KEY
      }
    });
    // Return the actual data, not the axios response wrapper
    return response.data;
  }
};
